$(document).ready(function() {
    var t = "", e = "";
    var defaultCountry = "QATAR"; // Set the default country to QATAR

    // Set the default selected country and show the country list
    $(".selected-country").text(defaultCountry); // Set the text to 'SAUDI ARABIA'
    $(".country-list li[data-country='" + defaultCountry + "']").addClass("selected"); // Set the corresponding list item as selected
    $(".country-list").hide();

    // Function to handle country selection
    $(".selected-country").click(function() {
        $(".country-list").toggle();
    });

    $(".country-list li").click(function() {
        var n = $(this).data("country");
        t = "";
        $(".selected-country").text(n);
        $(".country-list").hide();
        $(".country-list li").removeClass("selected");
        $(this).addClass("selected");

        // Handle the country data
        updateCountryData(n); // Call the function with the selected country
    });

    // Function to update country-specific data (languages and currency)
function updateCountryData(n) {
    var defaultCountry = "QATAR"; // Default country check
    var c = a[n] || [];
    var s = $(`.hidden_select a[data-country="${n}"]`);
    e = s.attr("href");
    $(".lang-select").empty();
    $(".p--crncy").empty();
    let l = "", o = false, r = false;

    c.forEach(function(t) {
        if (t.Language) {
            var e = "locale-" + t.Language.replace(/\s+/g, "_").toLowerCase();
            var a = ""; // Default unchecked

            // Only apply default checked logic for "SAUDI ARABIA"
            if (n === defaultCountry) {
                if (window.location.href.includes("/ar") && t.Language === "ARABIC") {
                    a = "checked"; // Default to Arabic if in `/ar`
                } else if (!window.location.href.includes("/ar") && t.Language === "ENGLISH") {
                    a = "checked"; // Default to English otherwise
                }
            } else {
                // For other countries, fallback to first language as default
                if (!r) {
                    a = "checked";
                    r = true;
                }
            }

            // Handle URL adjustments for language
            let currentUrl = window.location.href;
            let adjustedUrl = currentUrl;

            if (n === defaultCountry) {
    if (t.Language === "ARABIC") {
        // Add /ar only if not present
        if (!currentUrl.includes('/ar')) {
            const url = new URL(currentUrl);
            let pathname = url.pathname;

            // Ensure /ar is inserted after domain
            if (!pathname.startsWith('/ar')) {
                pathname = '/ar' + pathname;
            }

            url.pathname = pathname;
            adjustedUrl = url.toString();
        }
    } else if (t.Language === "ENGLISH") {
        // Remove /ar if present
        adjustedUrl = currentUrl.replace('/ar', '');
    }
}
 else {
                adjustedUrl = t.url; // For other countries, use static URLs
            }

            l += `
                <div class="form-cstm-control">
                    <input value="${t.Language}" type="radio" class="input-dyc" id="${e}" name="language" ${a} data-url="${adjustedUrl}">
                    <label class="custom-lbl" for="${e}">
                        ${t.text}
                    </label>
                </div>
            `;
            o = true;
        }
        if (t.money) {
            var currencyLabel = window.location.href.includes('/ar') ? 'عملة' : 'Currency';
            $(".p--crncy").html(`
                <label class="curren-ttl-i1 lang-lbl">${currencyLabel}</label>
                <p class="crs-mny">${t.text}</p>
            `);
        }
    });

    if (o) {
        // Check if the URL contains "/ar" to switch the language label
        var languageLabel = window.location.href.includes('/ar') ? 'اللغة‌' : 'Language';

        $(".lang-select").append(`
            <label class="lang-ttl-i1 lang-lbl">${languageLabel}</label>
            ${l}
        `);

        $(".input-dyc").click(function() {
            t = $(this).data("url");
        });
    }

    $(".lang-select").is(":empty") ? $(".lang-select").hide() : $(".lang-select").show();
    $(".p--crncy").is(":empty") ? $(".p--crncy").hide() : $(".p--crncy").show();

    // Add functionality for confirmcountry button
    $("#confirmcountry").click(function () {
    const currentUrl = window.location.href;
    const checkedInput = $(".input-dyc:checked");

    // CASE 1: If a language input is checked, use its data-url
    if (checkedInput.length > 0) {
        const selectedLang = checkedInput.val();

        // Prevent reload if already on the correct language version of the Care Guide page
        if ((currentUrl.includes("/pages/care-guide") || currentUrl.includes("/ar/pages/care-guide")) &&
            ((currentUrl.includes("/ar") && selectedLang === "ARABIC") ||
            (!currentUrl.includes("/ar") && selectedLang === "ENGLISH"))) {
            return false;
        }

        const selectedUrl = checkedInput.data("url");
        if (selectedUrl) {
            window.location.href = selectedUrl;
        }
        return;
    }

    // CASE 2: No language input exists — use the selected <li>'s data-url
    const selectedLi = $(".country-list li.selected");
    const fallbackUrl = selectedLi.data("url");

    if (fallbackUrl) {
        window.location.href = fallbackUrl;
    }
});
}


    // Hide country list if clicked outside
    $(document).click(function(t) {
        if (!$(t.target).closest(".slct-y-container").length) {
            $(".country-list").hide();
        }
    });

    // Default data for country selection
    const a = {
      "QATAR": [
            { Language: "ENGLISH", text: "ENGLISH", url: "https://www.sandro.qa/" },
            { Language: "ARABIC", text: "عربي", url: "https://www.sandro.qa/ar" },
        ],
        "SAUDI ARABIA": [
            { Language: "ENGLISH", text: "ENGLISH", url: "https://sandro.sa/" },
            { Language: "ARABIC", text: "عربي", url: "https://sandro.sa/ar" },
        ],
        "CANADA": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ca.sandro-paris.com/" },
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://ca.sandro-paris.com/fr/homepage" },
            { "money": "CURRENCY", "text": "C$ - CANADIAN DOLLAR" }
        ],
        "SPAIN": [
            { "Language": "ESPAÑOL", "text": "ESPAÑOL", "url": "https://es.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "UNITED STATES": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://us.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "$ - US DOLLAR" }
        ],
        "EUROPE": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://eu.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "FRANCE": [
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://fr.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "GERMANY": [
            { "Language": "DEUTSCH", "text": "DEUTSCH", "url": "https://de.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "IRELAND": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ie.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "ITALY": [
            { "Language": "ITALIANO", "text": "ITALIANO", "url": "https://it.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "NETHERLANDS": [
            { "Language": "NEDERLANDS", "text": "NEDERLANDS", "url": "https://nld.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "€ - EURO" }
        ],
        "UNITED KINGDOM": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://uk.sandro-paris.com/" },
            { "money": "CURRENCY", "text": "£ - POUND STERLING" }
        ],
        "SWITZERLAND": [
            { "Language": "ENGLISH", "text": "ENGLISH", "url": "https://ch.sandro-paris.com/" },
            { "Language": "FRANÇAIS", "text": "FRANÇAIS", "url": "https://ch.sandro-paris.com/fr_CH/homepage" },
            { "Language": "DEUTSCH", "text": "DEUTSCH", "url": "https://ch.sandro-paris.com/de_CH/homepage" },
            { "money": "CURRENCY", "text": "CHF - SWISS FRANC" }
        ],
    };

    updateCountryData(defaultCountry); 
});



// language drawer open
document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll('[data-action="locale-drawer"]'),t=document.querySelector(".right-side-pop-up"),n=document.querySelectorAll(".close-drawer");function c(e){document.body.classList.toggle("no-scroll",e)}e&&t&&e.forEach((function(e){e.addEventListener("click",(function(n){n.preventDefault(),e.classList.contains("header_drawer-dd")&&document.querySelector("#close-menu-drawer").click(),c(t.classList.toggle("open"))}))})),n.forEach((function(e){e.addEventListener("click",(function(){t&&(t.classList.remove("open"),c(!1))}))})),document.addEventListener("click",(function(n){t.contains(n.target)||[...e].some((e=>e.contains(n.target)))||(t.classList.remove("open"),c(!1))}))}));
// pdp slider js
$(document).ready((function(){function a(){var a=$(".gallery--view-imgs"),t=a.scrollTop(),i=a.height(),r=null;if($("li[data-media-id]").each((function(){var a=$(this),e=a.position().top+t;e+a.outerHeight()>t+i/2&&e<t+i/2&&(r=a)})),r){$("li[data-media-id]").removeClass("current"),r.addClass("current");var e=r.data("media-id");$("li[data-target]").removeClass("thumb-current"),$('li[data-target="'+e+'"]').addClass("thumb-current")}}function t(a){$("li[data-media-id]").removeClass("current"),a.length&&a.addClass("current")}t($("li[data-target]").first().addClass("thumb-current")),$("li[data-target]").on("click",(function(){var i=$(this).data("target"),r=$(this);$("li[data-target]").removeClass("thumb-current"),r.addClass("thumb-current");var e=$('li[data-media-id="'+i+'"]');t(e),function(a){var t=a.closest(".gallery--view-imgs");if(t.length){var i=a.position().top+t.scrollTop();t.animate({scrollTop:i},500)}}(e),a()})),$(".gallery--view-imgs").on("scroll",(function(){a()}))}));
// PDP Drawer
document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll(".desc-drw"),t=document.querySelector(".right-side-description"),r=document.querySelectorAll(".close-desc-drawer"),n=document.querySelector(".prev-a"),c=document.querySelector(".next-a"),o=document.querySelector(".prev-ttl"),l=document.querySelector(".next-ttl");function i(e){document.body.classList.toggle("disable-scroll",e)}function d(e){var r,d,a,m,f=document.querySelector(".drawer-p-description#"+e);document.querySelectorAll(".drawer-p-description").forEach((function(e){e.classList.remove("active")})),f&&f.classList.add("active"),t.classList.add("open-drawer"),i(!0),r=u(),d=document.querySelectorAll(".drawer-p-description").length,a=r>0?r-1:null,m=r<d-1?r+1:null,o.textContent=null!==a?s(a):"",l.textContent=null!==m?s(m):"",n.style.display=null!==a?"flex":"none",c.style.display=null!==m?"flex":"none"}function u(){var e=document.querySelector(".drawer-p-description.active");return Array.from(document.querySelectorAll(".drawer-p-description")).indexOf(e)}function a(e){return document.querySelectorAll(".drawer-p-description")[e]}function s(e){var t=a(e);return t?t.querySelector(".drawer-name").textContent.trim():""}e.length>0&&t&&e.forEach((function(e){e.addEventListener("click",(function(t){t.preventDefault(),d(e.getAttribute("id"))}))})),r.length>0&&r.forEach((function(e){e.addEventListener("click",(function(){t.classList.remove("open-drawer"),i(!1),document.querySelectorAll(".drawer-p-description").forEach((function(e){e.classList.remove("active")}))}))})),t&&document.addEventListener("click",(function(r){t.contains(r.target)||Array.from(e).some((e=>e.contains(r.target)))||(t.classList.remove("open-drawer"),i(!1),document.querySelectorAll(".drawer-p-description").forEach((function(e){e.classList.remove("active")})))})),n&&n.addEventListener("click",(function(){var e=u(),t=a(e>0?e-1:null);t&&d(t.getAttribute("id"))})),c&&c.addEventListener("click",(function(){var t=u(),r=a(t<e.length-1?t+1:null);r&&d(r.getAttribute("id"))}))}));
// pdp mobile discription show more show less
// document.addEventListener("DOMContentLoaded",(function(){const e=document.querySelectorAll(".description-dds"),n=document.querySelectorAll(".s-more"),t=document.querySelectorAll(".s-less");e.forEach(((e,d)=>{!function(e,n,t){n.addEventListener("click",(function(){e.classList.add("expanded"),n.style.display="none",t.style.display="inline"})),t.addEventListener("click",(function(){e.classList.remove("expanded"),n.style.display="inline",t.style.display="none"}))}(e,n[d],t[d])}))}));
document.addEventListener("DOMContentLoaded", function () {
    const descriptions = document.querySelectorAll(".description-dds"),
          showMoreButtons = document.querySelectorAll(".s-more"),
          showLessButtons = document.querySelectorAll(".s-less");

    descriptions.forEach((description, index) => {
        const showMore = showMoreButtons[index];
        const showLess = showLessButtons[index];

        if (showMore && showLess) {
            showMore.addEventListener("click", function () {
                description.classList.add("expanded");
                showMore.style.display = "none";
                showLess.style.display = "inline";
            });

            showLess.addEventListener("click", function () {
                description.classList.remove("expanded");
                showMore.style.display = "inline";
                showLess.style.display = "none";
            });
        }
    });
});
// size guide drawer 
document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll('[data-action="size-drawer"]'),t=document.querySelector(".right-side-size-drawer"),n=document.querySelectorAll(".close-sg-drawer");function c(e){document.body.classList.toggle("dont-scroll",e)}t&&(e.length>0&&e.forEach((function(e){e.addEventListener("click",(function(n){n.preventDefault(),e.classList.contains("header_drawer-dd")&&document.querySelector("#close-menu-drawer").click(),c(t.classList.toggle("open"))}))})),n.length>0&&n.forEach((function(e){e.addEventListener("click",(function(){t.classList.remove("open"),c(!1)}))})),document.addEventListener("click",(function(n){t.contains(n.target)||[...e].some((e=>e.contains(n.target)))||(t.classList.remove("open"),c(!1))})))}));
// media modal image show
document.querySelectorAll("li.mdl-thumb-img").forEach((function(t){t.addEventListener("click",(function(){document.querySelectorAll(".global-media-settings").forEach((function(t){t.classList.remove("active","highlight")})),document.querySelectorAll("li.mdl-thumb-img").forEach((function(t){t.classList.remove("thumb-image")}));var e=t.getAttribute("data-media-id");document.querySelectorAll(`.global-media-settings[data-media-id="${e}"]`).forEach((function(t){t.classList.add("highlight")})),document.querySelectorAll(`.global-media-settings[data-media-id="${e}"]`).forEach((function(t){t.classList.add("active")})),t.classList.add("thumb-image")}))}));
// Add click event listener for buttons
document.querySelectorAll("button.opn-tgl-img").forEach((function(t){t.addEventListener("click",(function(){var e=t.getAttribute("data-media-id");document.querySelectorAll("li.mdl-thumb-img").forEach((function(t){t.classList.remove("thumb-image")})),document.querySelectorAll(`li.mdl-thumb-img[data-media-id="${e}"]`).forEach((function(t){t.classList.add("thumb-image")}))}))}));
// video model
document.addEventListener("DOMContentLoaded",(function(){document.querySelectorAll(".modal-opener").forEach((function(e){e.addEventListener("click",(function(){const t=e.getAttribute("data-modal").replace("#",""),n=document.querySelector(`.one-new[id="${t}"]`);if(n){n.setAttribute("open","");const e=new MutationObserver((t=>{const o=n.querySelector("button.deferred-media__poster");o&&(o.click(),e.disconnect())}));e.observe(n,{childList:!0,subtree:!0})}}))}))})),document.addEventListener("DOMContentLoaded",(()=>{const e=document.querySelectorAll("video");setInterval((()=>{e.forEach((e=>{e.paused&&e.play()}))}),1e3),e.forEach((e=>{e.addEventListener("pause",(()=>{e.play()}))}))}));
// Account Drawer
document.addEventListener("DOMContentLoaded",(function(){var e=document.querySelectorAll('[data-action="account-drawer"]'),t=document.querySelector(".right-side-account-drawer"),n=document.querySelectorAll(".close-sg-drawer");function c(e){document.body.classList.toggle("dont-scroll",e)}t&&(e.length>0&&e.forEach((function(e){e.addEventListener("click",(function(n){n.preventDefault(),e.classList.contains("header_drawer-dd")&&document.querySelector("#close-menu-drawer").click(),c(t.classList.toggle("open"))}))})),n.length>0&&n.forEach((function(e){e.addEventListener("click",(function(){t.classList.remove("open"),c(!1)}))})),document.addEventListener("click",(function(n){t.contains(n.target)||[...e].some((e=>e.contains(n.target)))||(t.classList.remove("open"),c(!1))})))}));
// create account drawer
document.addEventListener("DOMContentLoaded",(function(){const e=document.getElementById("ca-drawer"),t=document.querySelector(".ac--inner-drawer"),n=document.getElementById("template");e&&t&&n&&e.addEventListener("click",(function(){t.classList.add("open");const e=t.querySelector(".back-prev-pg");e&&e.addEventListener("click",(function(){t.classList.remove("open")}))}))}));
// forgot password drawer
document.addEventListener("DOMContentLoaded",(function(){const e=document.querySelector(".frgt-password"),t=document.querySelectorAll(".back-pg-btn"),n=document.querySelector(".recover-yr-psw-drawer");e&&e.addEventListener("click",(function(e){e.preventDefault(),n&&n.classList.add("open")})),t.length>0&&t.forEach((function(e){e.addEventListener("click",(function(){const e=this.closest(".recover-yr-psw-drawer");e&&e.classList.remove("open")}))}))}));
// scroll from faq page 
document.addEventListener('DOMContentLoaded', function() {
    function smoothScrollToElement(selector) {
        const targetElement = document.querySelector(selector);
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
    smoothScrollToElement('.show-faq-breadcrumbs');
});
// sticky add to cart remove 
function toggleVisibilityOnScroll() {
    const targetElement = document.querySelector('.product-color-size-container');
    const scrollThreshold = 1800;
    if(targetElement) {
    if (window.scrollY > scrollThreshold) {
        targetElement.classList.add('d-none');
    } else {
        targetElement.classList.remove('d-none');
    }
   } 
}
// Add an event listener for the scroll event
window.addEventListener('scroll', toggleVisibilityOnScroll);
// video play off 
document.addEventListener("DOMContentLoaded",(function(){const e=document.querySelector(".desk-video video"),d=document.querySelector(".mob-video video"),t=document.getElementById("fw-video-volume-button"),i=document.querySelector(".unmute-video-icon"),o=document.querySelector(".mute-video-icon");if(e&&d&&t&&i&&o){function s(){e.muted=!1,d.muted=!1,t.classList.add("video-is-unmuted"),t.classList.remove("video-is-muted")}function u(){e.muted=!0,d.muted=!0,t.classList.add("video-is-muted"),t.classList.remove("video-is-unmuted")}function n(){e.muted?s():u()}i.addEventListener("click",s),o.addEventListener("click",u),e.addEventListener("click",n),d.addEventListener("click",n),e.muted?(t.classList.add("video-is-muted"),t.classList.remove("video-is-unmuted")):(t.classList.add("video-is-unmuted"),t.classList.remove("video-is-muted"))}}));
document.addEventListener('DOMContentLoaded', function() {
  var brandPage = document.querySelector('.the-sandro-brand-page');
  var pageTitle = document.querySelector('.main-page-title');
  var maincontainer = document.querySelector('.pg-default-containt');
  var breadcrumb = document.querySelector('.breadcrumbs__list');
  
  if (brandPage && pageTitle && maincontainer && breadcrumb) {
    pageTitle.style.display = 'none';
    maincontainer.style.paddingTop = '0px';
    maincontainer.style.paddingBottom = '0px';
    breadcrumb.style.display = 'block';
  }
});

// Translate Boost Search "Size Chart" suggestion to Arabic
(function () {
    if (!window.location.href.includes('/ar')) return;

    const observer = new MutationObserver(() => {

        document.querySelectorAll('.boost-sd__suggestion-queries-item').forEach(item => {

            const span = item.querySelector('span');
            if (!span) return;

            const text = span.textContent.trim().toLowerCase();

            if (text === 'size chart' || text === 'sizechart') {
                span.textContent = 'جدول المقاسات';
            }
            if (text === 'size' || text === 'sizes') {
                span.textContent = 'المقاسات'
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();

document.addEventListener("DOMContentLoaded", function () {
    const doc = document;
    /* EMAIL SYNC */
    const mainEmailInput = doc.querySelector("#CustomerEmailValidate");
    const continueBtn = doc.querySelector(".email-drwer .continue-btn");
    const caDrawerBtn = doc.querySelector("#ca-drawer");
    const frgtPasswordBtn = doc.querySelector(".frgt-password");

    if (mainEmailInput) {
        let emailTimeout;
        const updateEmails = () => {
            const emailValue = mainEmailInput.value.trim();
            if (!emailValue) return;
            const loginEmail = doc.querySelector("#CustomerEmail");
            const recoverEmail = doc.querySelector("#RecoverEmail");
            const cfEmailInput = doc.querySelector('form#create_customer input[type="email"]' );

            // Login Email
            if (loginEmail && loginEmail.value !== emailValue) {
                loginEmail.value = emailValue;
                loginEmail.dispatchEvent(
                    new Event("input", { bubbles: true })
                );
                loginEmail.dispatchEvent(
                    new Event("change", { bubbles: true })
                );
            }

            // Recover Email
            if (recoverEmail && recoverEmail.value !== emailValue) {
                recoverEmail.value = emailValue;
                recoverEmail.dispatchEvent(
                    new Event("input", { bubbles: true })
                );
                recoverEmail.dispatchEvent(
                    new Event("change", { bubbles: true })
                );
            }

            // Create Account Email
            if (cfEmailInput && cfEmailInput.value !== emailValue) {
                const setter = Object.getOwnPropertyDescriptor(
                    window.HTMLInputElement.prototype,
                    "value"
                )?.set;
                if (setter) {
                    setter.call(cfEmailInput, emailValue);
                } else {
                    cfEmailInput.value = emailValue;
                }
                cfEmailInput.dispatchEvent(
                    new Event("input", { bubbles: true })
                );
                cfEmailInput.dispatchEvent(
                    new Event("change", { bubbles: true })
                );
            }
        };
        const safeUpdateEmails = () => {
            clearTimeout(emailTimeout);
            emailTimeout = setTimeout(() => {
                updateEmails();
            }, 100);
        };
        [continueBtn, caDrawerBtn, frgtPasswordBtn].forEach(btn => {
            if (btn) {
                btn.addEventListener("click", safeUpdateEmails);
            }
        });
    }

    /* PHONE VALIDATION */

    function initPhoneValidation() {
        const phoneInput = doc.querySelector('input[name="phone"]');
        const countrySelect = doc.querySelector('.cf-country-picker select');
        if (!phoneInput || !countrySelect) return false;
        if (phoneInput.dataset.initDone) return true;
        phoneInput.dataset.initDone = "true";
        const phoneLimits = {
            AE: { code: "971", localLimit: 9 },
            SA: { code: "966", localLimit: 9 },
            KW: { code: "965", localLimit: 8 },
            QA: { code: "974", localLimit: 8 }
        };

        const getConfig = () => { return phoneLimits[countrySelect.value] || null; };

        // Reset on country change
        countrySelect.addEventListener("change", () => {
            setTimeout(() => {
                phoneInput.value = "";
                phoneInput.setCustomValidity("");
                phoneInput.dispatchEvent( new Event("input", { bubbles: true }) );
            }, 10);
        });

        // Limit typing
        phoneInput.addEventListener("keydown", function (e) {
            const config = getConfig();
            if (!config) return;
            if ( /^\d$/.test(e.key) && this.selectionStart === this.selectionEnd ) {
                const digits = this.value.replace(/\D/g, '');
                const max = config.code.length + config.localLimit;

                if (digits.length >= max) {
                    e.preventDefault();
                }
            }
        });

        // Clean input
        phoneInput.addEventListener("input", function () {
            const config = getConfig();
            if (!config) return;
            let digits = this.value.replace(/\D/g, '');
            const hasPlus = this.value.startsWith('+');
            if (!digits) {
                this.value = hasPlus ? '+' : '';
                return;
            }
            let max = config.localLimit;
            if (digits.startsWith(config.code)) {
                max = config.code.length + config.localLimit;
            } else if (digits.startsWith('0')) {
                max = config.localLimit + 1;
            }
            digits = digits.substring(0, max);
            this.value = hasPlus ? '+' + digits : digits;
            this.setCustomValidity('');
        });

        // Final validation
        phoneInput.addEventListener("blur", function () {
            const config = getConfig();
            if (!config) return;
            const digits = this.value.replace(/\D/g, '');
            let max = config.localLimit;
            if (digits.startsWith(config.code)) {
                max = config.code.length + config.localLimit;
            } else if (digits.startsWith('0')) {
                max = config.localLimit + 1;
            }
            if (digits && digits.length !== max) {
                this.setCustomValidity( `Phone number must contain ${max} digits.` );
            } else {
                this.setCustomValidity('');
            }
            this.reportValidity();
        });

        // Remove error on focus
        phoneInput.addEventListener("focus", function () {
            this.setCustomValidity('');
        });
        return true;
    }

    /* PASSWORD VALIDATION */
    function initPasswordValidation() {
        const inputs = doc.querySelectorAll('input[data-cf-column-key="password"], input[name="password"]');
        let initialized = false;
        inputs.forEach(input => {
            if (input.dataset.vDone) return;
            const desc = doc.getElementById( input.getAttribute('aria-describedby') );
            if (!desc) return;
            input.dataset.vDone = "true";
            initialized = true;
            input.type = 'password';
            const parent = input.closest('.cf-field');

            /* PASSWORD TOGGLE */
            if (parent && !parent.querySelector('.password-show')) {
                parent.style.position = 'relative';
                const toggle = doc.createElement('span');
                toggle.className = 'password-show';
                parent.appendChild(toggle);
                toggle.addEventListener('click', (e) => {

                    e.preventDefault();

                    input.type =
                        input.type === 'password'
                            ? 'text'
                            : 'password';

                    toggle.classList.toggle('show');
                });
            }

            /* VALIDATE PASSWORD */
            const validate = () => {
                const val = input.value;
                const isLen = val.length >= 8;
                const isLet = /[a-zA-Z]/.test(val);
                const isNum = /[0-9]/.test(val);

                // BOTH TARGETS
                const targets = [ desc, parent?.querySelector('.cf-field-errors span[role="alert"]')];

                targets.forEach(target => {
                    if (!target) return;
                    /* WRAP ONLY ONCE */
                    if (!target.dataset.validationInit) {
                        target.innerHTML = target.innerHTML
                            .replace(
                                /8 characters|8 أحرف/i,
                                '<span class="v-len">$&</span>'
                            )
                            .replace(
                                /1 letter|حرف واحد/i,
                                '<span class="v-let">$&</span>'
                            )
                            .replace(
                                /1 number|رقم واحد/i,
                                '<span class="v-num">$&</span>'
                            );
                        target.dataset.validationInit = "true";
                    }
                    /* UPDATE COLORS */
                    const setColor = (selector, valid) => {
                        const el = target.querySelector(selector);
                        if (el) {
                            el.style.color = valid ? '#4aa851' : (val ? '#e22120' : '');
                        }
                    };
                    setColor('.v-len', isLen);
                    setColor('.v-let', isLet);
                    setColor('.v-num', isNum);
                });
            };
            input.addEventListener('input', validate);
            validate();
        });
        return initialized;
    }

    /* GLOBAL OBSERVER */
    let observerTimeout;
    const observer = new MutationObserver(() => {
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
            initPhoneValidation();
            initPasswordValidation();
        }, 200);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    /* INITIAL RUN */
    initPhoneValidation();
    initPasswordValidation();
});